// test2517
(2517 && 0);
